export type ProductState = {
  activeProducts: string[],
  addOns: string[],
};

// Add-ons extend Inköp, and Försäljning already includes what they offer.
export const offersPurchasingAddOns = (activeProducts: string[]): boolean =>
  activeProducts.includes('PURCHASING') && !activeProducts.includes('SALES');

export const nextProducts = ({ activeProducts, addOns }: ProductState, product: string): ProductState => {
  const toggled = activeProducts.includes(product)
    ? activeProducts.filter(p => p !== product)
    : [...activeProducts, product];
  return { activeProducts: toggled, addOns: offersPurchasingAddOns(toggled) ? addOns : [] };
};
